<template>
  <div>
    <ClientOnly>
      <HeadlessPopover
        v-if="useTemplateStoreInstance.header.showPopover === true"
        v-slot="{ open }"
        class="relative flex items-center justify-between h-full"
      >
        <HeadlessPopoverButton
          :class="open ? ' ring-2 ring-primary-500 ring-offset-2' : ''"
          class="rounded-full outline-none transition duration-200 ease-out focus-visible:ring-primary-400 focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-none"
        >
          <div
            class="flex max-w-xs items-center bg-white text-sm h-8 w-8 rounded-full"
          >
            <span class="sr-only">{{ $t('a11y.open-menu') }}</span>
            <AuthAvatar :compact="true" />
          </div>
        </HeadlessPopoverButton>

        <transition
          enter-active-class="transition duration-200 ease-out"
          enter-from-class="translate-y-1 opacity-0"
          enter-to-class="translate-y-0 opacity-100"
          leave-active-class="transition duration-150 ease-in"
          leave-from-class="translate-y-0 opacity-100"
          leave-to-class="translate-y-1 opacity-0"
        >
          <div v-if="open">
            <LazyRenderTemplatePopoverPanel />
          </div>
        </transition>
      </HeadlessPopover>
      <AuthHeader
        v-if="useTemplateStoreInstance.header.showPopover === false"
        :compact="true"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { useTemplateStore } from '~/modules/template/stores/useTemplateStore'

const useTemplateStoreInstance = useTemplateStore()
</script>
